import { Button, IconPropsStrict } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { PortalMode } from '../../../stores/portal.store';
import { EmptyResults } from '../../empty';
import { ContentBlock } from '../content';
import * as Styles from './content-empty.module.less';

export const ContentBlockEmpty: FC<{
    className?: string;
    mode: PortalMode;
    title: string;
    description: string;
    image?: string;
    iconName?: IconPropsStrict['name'];
    children?: ReactNode;
}> = ({ children, className, description, iconName, image, mode, title }) => (
    <ContentBlock
        className={classNames(
            Styles.empty,
            { 'flex-grow-1 flex-basis-0 d-f': mode.mobile },
            className
        )}
        contentClassName={classNames('d-f flex-column', {
            'flex-grow-1 flex-basis-0': mode.mobile,
            'align-items-center': !mode.mobile,
        })}
        centered={!mode.mobile}
    >
        <EmptyResults
            className={classNames({
                'flex-grow-1 flex-basis-0': mode.mobile,
                'm-b-3': !mode.mobile,
            })}
            title={title}
            description={description}
            image={image}
            iconName={iconName}
        />

        {children}
    </ContentBlock>
);

export const ContentBlockEmptyFilters: FC<{
    mode: PortalMode;
    filtered: boolean;
    titleNoFilters?: string;
    descriptionNoFilters?: string;
    imageNoFilters?: string;
    children?: ReactNode;
    resetFilters(): void;
}> = ({
    children,
    descriptionNoFilters,
    filtered,
    imageNoFilters,
    mode,
    resetFilters,
    titleNoFilters,
}) => (
    <ContentBlockEmpty
        mode={mode}
        title={filtered ? `No Results Found` : (titleNoFilters ?? `No Items`)}
        description={
            filtered
                ? 'Please modify your search by changing filter criteria.'
                : (descriptionNoFilters ?? `You don’t have any items.`)
        }
        image={filtered ? undefined : imageNoFilters}
    >
        {filtered && (
            <Button iconName="cached" onClick={() => resetFilters()}>
                Reset Filters
            </Button>
        )}

        {children}
    </ContentBlockEmpty>
);
